export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.prompt': 'Prompt Management',
  'menu.prompt.new-page': 'New Page Management',
  'menu.prompt.page': 'Page Management',
  'menu.prompt.doll': 'Doll Management',
  'menu.prompt.character-card': 'Character Card',
  'menu.prompt.free-dialogue': 'Free Dialogue',
  'menu.prompt.prompt-word': 'AI Analysis',
  'menu.user-management': 'User Management',
  'menu.user-management.mini-program-user': 'Mini Program User',
  'menu.user-management.user-feedback': 'User Feedback',
  'menu.device-management': 'Device Management',
  'menu.device-management.list': 'Device List',
  'menu.device-management.device-data': 'Device Data',
  'menu.flow-package': 'Flow Package',
  'menu.flow-package.package-list': 'Package Management',
  'menu.flow-package.order-list': 'Order Management',
  'menu.log-management': 'Log Management',
  'menu.log-management.message-log': 'Message Log',
  'menu.system': 'System',
  'menu.system.dict': 'Dictionary',
  'menu.system.notice': 'Notice',
  'menu.system.help-center': 'Help Center',
  'menu.system.privacy-agreement': 'Config Center',
};
